var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavArrowDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.143 20.12-8.99-8.71a1.087 1.087 0 0 0-1.505-.005 1.006 1.006 0 0 0 .005 1.458l9.735 9.43.002.003.003.002c.208.202.478.301.749.3.274 0 .544-.1.75-.3l.003-.002.003-.003 9.734-9.43c.42-.406.42-1.057.006-1.458a1.086 1.086 0 0 0-1.505.006l-8.99 8.709z",
    fill: "#F9F7F1",
    fillRule: "nonzero",
    stroke: "#F9F7F1",
    strokeWidth: 0.439
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArrowDown);
export default __webpack_public_path__ + "static/media/nav-arrow-down.6127ee45732e0aaafd75e654c6f3f79e.svg";
export { ForwardRef as ReactComponent };